<template>
  <popper :options="{ placement: 'bottom', 'visible-arrow': false }" trigger="clickToToggle">
    <div class="popper-content text-left py-1">
      <div v-for="locale in d_locales" @click="setLocale(locale)" :key="`locale-${locale}`" class="cursor-pointer mb-1">
        <img :src="require(`@/assets/images/flags/${locale}.png`)" :alt="locale" :title="locale">
      </div>
    </div>

    <div class="cursor-pointer" slot="reference">
      <img :src="require(`@/assets/images/flags/${c_selectedLocale}.png`)" :alt="c_selectedLocale" :title="c_selectedLocale">
    </div>
  </popper>
</template>

<script>
import Popper from 'vue-popperjs';
import { localStorageKey } from '@/i18n/i18n.config';

export default {
  name: 'locale-select',
  components: { Popper },
  data () {
    return {
      d_locales: [],
    };
  },
  created() {
    // Get all the translation file names
    const locales = require.context('@/i18n/translations', true, /[A-Za-z0-9-_,\s]+\.json$/i);

    // Loop through file names and strip to just the locale
    locales.keys().forEach(key => {
      const locale = key.match(/([A-Za-z0-9-_]+)/i)[0];

      this.d_locales.push(locale);
    });
  },
  computed: {
    c_selectedLocale () {
      return this.d_locales.find((locale) => locale === this.$i18n.locale) || {};
    },
  },
  methods: {
    setLocale(locale) {
      // Set the chosen locale and update local storage to save preference.
      this.$i18n.locale = locale;

      localStorage.setItem(localStorageKey, this.$i18n.locale);
    },
  },
}
</script>
